import { Box } from "@mui/material";
import TextButton from "../../components/buttons/TextButton";

export default function TextButtonDemo() {
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box display="flex" gap={2} alignItems="center">
        <TextButton onClick={() => {}} color="inherit" size="large">
          Inherit Large
        </TextButton>
        <TextButton onClick={() => {}} color="inherit" size="medium">
          Inherit Medium
        </TextButton>
        <TextButton onClick={() => {}} color="inherit" size="small">
          Inherit Small
        </TextButton>
        <TextButton onClick={() => {}} color="inherit" size="xs">
          Inherit XS
        </TextButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center">
        <TextButton onClick={() => {}} color="primary" size="large">
          Primary Large
        </TextButton>
        <TextButton onClick={() => {}} color="primary" size="medium">
          Primary Medium
        </TextButton>
        <TextButton onClick={() => {}} color="primary" size="small">
          Primary Small
        </TextButton>
        <TextButton onClick={() => {}} color="primary" size="xs">
          Primary XS
        </TextButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center">
        <TextButton onClick={() => {}} color="success" size="large">
          Success Large
        </TextButton>
        <TextButton onClick={() => {}} color="success" size="medium">
          Success Medium
        </TextButton>
        <TextButton onClick={() => {}} color="success" size="small">
          Success Small
        </TextButton>
        <TextButton onClick={() => {}} color="success" size="xs">
          Success XS
        </TextButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center">
        <TextButton onClick={() => {}} color="error" size="large">
          Error Large
        </TextButton>
        <TextButton onClick={() => {}} color="error" size="medium">
          Error Medium
        </TextButton>
        <TextButton onClick={() => {}} color="error" size="small">
          Error Small
        </TextButton>
        <TextButton onClick={() => {}} color="error" size="xs">
          Error XS
        </TextButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center">
        <TextButton
          onClick={() => {}}
          color="primary"
          size="large"
          disabled={true}
        >
          Disabled
        </TextButton>
        <TextButton
          onClick={() => {}}
          color="primary"
          size="medium"
          disabled={true}
        >
          Disabled
        </TextButton>
        <TextButton
          onClick={() => {}}
          color="primary"
          size="small"
          disabled={true}
        >
          Disabled
        </TextButton>
        <TextButton
          onClick={() => {}}
          color="primary"
          size="xs"
          disabled={true}
        >
          Disabled
        </TextButton>
      </Box>
      <Box display="flex" gap={2} alignItems="center">
        <TextButton
          onClick={() => {}}
          color="primary"
          size="large"
          loading={true}
        >
          Disabled
        </TextButton>
        <TextButton
          onClick={() => {}}
          color="primary"
          size="medium"
          loading={true}
        >
          Disabled
        </TextButton>
        <TextButton
          onClick={() => {}}
          color="primary"
          size="small"
          loading={true}
        >
          Disabled
        </TextButton>
        <TextButton onClick={() => {}} color="primary" size="xs" loading={true}>
          Disabled
        </TextButton>
      </Box>
    </Box>
  );
}
